export const makeObjectFromArray = (array, keyFn, objectFn) => Object.fromEntries(array.map(object => ([keyFn(object), objectFn(object)])));